import { lazy } from 'react';

const AssociatedTransformersConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/verifier/consult/associated-transformers',
			component: lazy(() => import('./AssociatedTransformersContainer'))
		}
	]
};

export default AssociatedTransformersConfig;


